<template lang="pug">
.list-data
  .title-section.pointer(@click="toggleFilters") {{ title }}
    .tag(v-if="data.totalDocs")  {{ data.totalDocs }}
    shExpandButton(:expand="filters.expand")

  transition(name="slide-fade")
    shFilters(v-if="filters.expand" :resolver="resolver" @getPage="getPage")

  .headers-list-data-order(v-if="resolver === 'orders' || resolver === 'changes'")
    div(@click="showSettings")
      img.print-image(:src="require('@/assets/table.svg')" alt="table")
    router-link.dark.fine-pointer(v-if="resolver === 'changes'" to="/print-return-address-changes")
      img.print-image(:src="require('@/assets/print.svg')" alt="print")

    .left(v-if="resolver === 'changes'")
      .check-list.fine-pointer
        .input-container-checkbox.lonely
          label.label-checkbox(for="CheckListData")
            input.input-checkbox(v-model="checked" id="CheckListData" type="checkbox" @change="changeCheckList")
            .checkmark

  shLoader(:show="isLoading")
  div(v-if="!data.docs.length && !newData.length && !isLoading") No hay datos para mostrar

  .list-data-container
    transition-group(name="slide-fade")
      component(:is="component" v-for="(d, index) in data.docs" :data="d" :isNew="false" :realIndex="index" :index="getIndex(index)" :key="`${d[keyData]}${keyData1 ? d[keyData1] : ''}`" :history="history")

  shNavigation(v-if="data.docs.length" :data="data" @getPage="getPage")

  shSettingsTable(v-if="showSettingsTable")
</template>

<script>
import shUser from '@/components/pages/user/User'
import shColor from '@/components/pages/color/Color'
import shConfig from '@/components/pages/config/Config'
import shDesign from '@/components/pages/design/Design'
import shSize from '@/components/pages/size/Size'
import shArticle from '@/components/pages/article/Article'
import shProduct from '@/components/pages/product/Product'
import shLabel from '@/components/pages/label/Label'
import shTier from '@/components/pages/tier/Tier'
import shTemporaryStock from '@/components/pages/temporaryStock/TemporaryStock'
import shLocation from '@/components/pages/location/Location'
import shCode from '@/components/pages/code/Code'
import shArticleDefault from '@/components/pages/articleDefault/ArticleDefault'
import shMethod from '@/components/pages/method/Method'
import shConveyor from '@/components/pages/conveyor/Conveyor'
import shImage from '@/components/pages/image/Image'
import shOrder from '@/components/pages/order/Order'
import shOrderDropshipping from '@/components/pages/orderDropshipping/OrderDropshipping'
import shOrderWholesaler from '@/components/pages/orderWholesaler/OrderWholesaler'
import shDelivery from '@/components/pages/delivery/Delivery'
import shRefund from '@/components/pages/refund/Refund'
import shInvoice from '@/components/pages/invoice/Invoice'
import shPrice from '@/components/pages/price/Price'
import shChange from '@/components/pages/change/Change'
import shGiftVoucher from '@/components/pages/giftVoucher/GiftVoucher'
import shGiftMessage from '@/components/pages/giftMessage/GiftMessage'
import shSet from '@/components/pages/set/Set'
import shBonus from '@/components/pages/bonus/Bonus'
import shCustomer from '@/components/pages/customer/Customer'
import shFaq from '@/components/pages/faq/Faq'
import shFeedback from '@/components/pages/feedback/Feedback'
import shBan from '@/components/pages/ban/Ban'
import shFraudCase from '@/components/pages/fraudCase/FraudCase'
import shFraudReport from '@/components/pages/fraudReport/FraudReport'
import shSettingsTable from '@/components/global/SettingsTable'

import shOrderForm from '@/components/pages/order/Form'

import shFilters from '@/components/helpers/Filters'
import shNavigation from '@/components/helpers/Navigation'

import shExpandButton from '@/components/elements/ExpandButton'

import shLoader from '@/components/layout/Loader'

import mFilters from '@/mixins/filters'

import { applyQueryParamsToStore } from '@/utils/urlFilters'

export default {
  name: 'ListData',

  components: { shLoader, shUser, shColor, shArticle, shDesign, shProduct, shSize, shCode, shLocation, shConveyor, shArticleDefault, shMethod, shImage, shFilters, shNavigation, shExpandButton, shLabel, shTier, shTemporaryStock, shOrder, shDelivery, shPrice, shOrderWholesaler, shRefund, shInvoice, shConfig, shOrderDropshipping, shChange, shGiftVoucher, shSet, shGiftMessage, shBonus, shCustomer, shFaq, shFeedback, shBan, shFraudCase, shFraudReport, shOrderForm, shSettingsTable },

  mixins: [mFilters],

  props: {
    title: String,
    resolver: String,
    keyData: String,
    keyData1: String,
    component: String,
    history: Boolean,
    company: String
  },

  created () {
    this.$store.commit('loadFieldsOrder')
    const limitSaved = localStorage.getItem(`limit-${this.resolver}`)
    if (limitSaved) this.$store.commit('setConfigPage', { resolver: this.resolver, key: 'limit', value: parseInt(limitSaved) })

    // Aplicar filtros desde query params de la URL
    if (Object.keys(this.$route.query).length > 0) {
      const listConfig = this.$store.state.list[this.resolver]
      const searchByFields = listConfig && listConfig.searchBy ? listConfig.searchBy : []
      applyQueryParamsToStore(this.$store, this.resolver, this.$route.query, searchByFields)
    }
  },

  mounted () {
    this.getPage()
  },

  data () {
    return {
      checked: false
    }
  },

  methods: {
    getPage (page = 1) {
      this.$store.commit('getData', { resolver: this.resolver, page, key: this.keyData })
    },
    getIndex (index) {
      const fixerIndexAccordPage = this.data.limit * (this.data.page - 1)
      if (this.filters.order === '-') {
        return this.data.totalDocs - index - fixerIndexAccordPage - 1
      } else {
        return index + fixerIndexAccordPage
      }
    },
    toggleFilters () {
      this.$store.commit('setConfigPage', { resolver: this.resolver, key: 'expand', value: !this.filters.expand })
    },
    changeCheckList () {
      this.$store.commit('changeCheckList', { resolver: this.resolver, value: this.checked })
    },
    showSettings () {
      this.$store.commit('showSettings')
    }
  },

  computed: {
    data () {
      const resolverData = this.$store.state.data[this.resolver]
      return resolverData && resolverData.data ? resolverData.data : { docs: [] }
    },
    newData () {
      const resolverData = this.$store.state.data[this.resolver]
      return resolverData && resolverData.new ? resolverData.new : []
    },
    filters () {
      return this.$store.state.filters[this.resolver]
    },
    totalsDeliveries () {
      if (this.resolver !== 'deliveries') return
      const totals = this.data.docs.reduce((totals, delivery) => {
        if (!delivery.collectedBy) totals.charge += delivery.replacementCharge || delivery.charge || 0
        if (!delivery.paidBy) totals.pay += delivery.cost || 0
        return totals
      }, { pay: 0, charge: 0 })
      return totals
    },
    balance () {
      return this.$store.state.variables.balance
    },
    showSettingsTable () {
      return this.$store.state.interface.settings.show
    },
    isLoading () {
      return this.$store.state.data.isLoading
    }
  }
}
</script>

<style lang="stylus">
.title-section
  font-size 1.3em
  font-weight 600
  margin-bottom 1em
  display flex
  align-items center
  gap 1em
  text-transform uppercase

.list-data
  position relative
  padding-bottom 40em

.headers-list-data-order
  display flex
  justify-content flex-end
  padding .5rem 1rem
  gap 1rem
  align-items center

.balance-deliveries
  font-size 1.1em
  font-weight 600

.divider-important
  width 100%
  border 2px dashed #FF5968
  margin 3em 0

.table-image
  height 1.38rem

/* .list-data-container
  border-bottom 1px solid #c8c8c8 */
</style>



// WEBPACK FOOTER //
// src/components/global/ListData.vue